module.exports = __webpack_public_path__ + "img/img0.8397d5a9.jpg";